export const LOCAL_STORAGE_SESSION_TOKEN_KEY = 'sessionToken'
export const HTTP_HEADER_SESSION_TOKEN_KEY = 'X-Session-Token'
export const HTTP_HEADER_BRANCH_KEY = 'X-Branch'
export const LOCAL_STORAGE_BRANCH_ID_KEY = 'branchId'

export const STYLE_FILL_COLOR = 'fillColor'